import { render, staticRenderFns } from "./NewEditLinkedSearch.vue?vue&type=template&id=63524e75&scoped=true&"
import script from "./NewEditLinkedSearch.vue?vue&type=script&lang=js&"
export * from "./NewEditLinkedSearch.vue?vue&type=script&lang=js&"
import style0 from "./NewEditLinkedSearch.vue?vue&type=style&index=0&id=63524e75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63524e75",
  null
  
)

export default component.exports